import {
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  SUPPORTED_LANGUAGES
} from '@/constants/trans';
import ar from '@/lang/ar.json';
import de from '@/lang/de.json';
import en from '@/lang/en.json';
import es from '@/lang/es.json';
import pt_BR from '@/lang/pt_BR.json';
import pt_PT from '@/lang/pt_PT.json';
import store from '@/store';
import axios from 'axios';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: { es, en, de, pt_BR, ar, pt_PT },
  sync: true
});

function setI18nLanguage(lang) {
  i18n.locale = lang;
  window.$cookies.set(
    'lang',
    lang,
    Infinity,
  );
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  store.commit('setLang', lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  lang = window.$cookies.get('lang') || lang;

  if (!lang) {
    lang = window.navigator.language || window.navigator.userLanguage;
    lang = lang.replace('-', '_');

    if (SUPPORTED_LANGUAGES.filter(e => e.code === lang).length === 0) {
      lang = lang.split('_')[0];
    }
  }

  if (SUPPORTED_LANGUAGES.filter(e => e.code === lang).length === 0) {
    lang = FALLBACK_LANGUAGE;
  }

  setI18nLanguage(lang);
}
